import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AlertDialogComponent} from "../app/peticiones/alert-dialog/alert-dialog.component";
import {Environment} from "@angular/cli/lib/config/workspace-schema";
import {environment} from "../environments/environment";
import {FuncionesExterno} from "../app/externo/funciones-Externo";

export class PetTall {

    public static prefix:string  = "pt";

    empresa?: number;

    periode: number = 0;

    peticio?: number;

    fecha?: Date;

    hora?: string;

    articulo?: string;

    ref_prov?: string;

    descr?: string;

    descr2?: string;

    bastidor?: string;

    cant?: number;

    hoja: number = 0;

    ser_ped_pro?: string;

    num_ped_pro?: number;

    lin_ped_pro?: number;

    ser_alb_pro?: string;

    num_alb_pro?: number;

    lin_alb_pro?: number;

    ser_alb?: string;

    num_alb?: number;

    lin_alb?: number;

    obser?: string;

    proved?: string;

    pre_com?: number;

    dto_com?: number;

    pre_ces?: number;

    pvp?: number;

    par_001?: string;

    par_002?: string;

    par_003?: string;

    par_004?: string;

    par_005?: string;

    par_006?: string;

    par_007?: string;

    par_008?: string;

    par_009?: string;

    par_010?: string;

    par_013?: string;

    art_stk?: string;

    alm_reg?: number;

    created?: Date;

    modified?: Date;

    fec_prev?: Date;

    fec_prev_tall?: Date;

    usuari?: string;

    oem?: string;

    peticion_padre?: number;


    public updatePeticionExterno(http:HttpClient){
        const headers = { 'Authorization': 'Bearer ' + FuncionesExterno.getToken()};
        return new Promise<any[]>((resolve, reject) =>
        {
            http.post<any>(environment.articulosWSBase + "/PetTall/updatePetTallAccessToken", this,  { headers } )
                .subscribe
                ({
                    next(res)
                    {
                        resolve(res);
                    },
                    error(err)
                    {
                        console.error(err);
                        reject(err);
                    },
                })
        });
    }
}
